export default "__VITE_ASSET__DPX12Itz__"